import { TextValue } from "../../tableElements";
import HighlightTextValue from "@/components/tableElements/HighlightTextValue.vue";
import { WrapWithSectionItem } from "../sections";
import { truncateString } from "@/utils";
export default {
  name: "TargetingFilterItem",
  emits: ["select", "selectOnly", "deselect"],
  props: {
    targeting: {
      type: String
    },
    selected: {
      type: Boolean,
      default: false
    },
    // Search term to highlight within the label.
    query: {
      type: String,
      default: ""
    }
  },
  components: {
    WrapWithSectionItem,
    TextValue,
    HighlightTextValue
  },
  methods: {
    truncateString
  }
};